import { useCurrentWallet, useDevMode } from '@plug-core/state'
import { useFindTokensProvider } from '@providers/FindTokensProvider'
import { Button } from '@ui'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { HiAdjustments } from 'react-icons/hi'
import { IoSync } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'

export const TokenListButtons = () => {
  const { devEnabled } = useDevMode()
  const { findTokens, loading } = useFindTokensProvider()
  const { currentWallet } = useCurrentWallet()
  const { t } = useTranslation()

  const navigate = useNavigate()

  return (
    <div className="mx-auto mt-4 mb-3 flex flex-wrap justify-center gap-3">
      {!devEnabled && (
        <Button
          variant="ghost"
          size="sm"
          startIcon={<HiAdjustments aria-hidden="true" />}
          onClick={() => navigate(`${ROUTES.MANAGE_TOKENS}`)}
        >
          {t('home.tokenListButtons.manage')}
        </Button>
      )}

      <Button
        variant="ghost"
        size="sm"
        startIcon={<IoSync aria-hidden="true" />}
        onClick={() => findTokens(currentWallet)}
        loading={loading}
      >
        {t('home.tokenListButtons.findTokens')}
      </Button>
    </div>
  )
}
